// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".batch-settings-dialog .range-selector{height:10px!important}.batch-settings-dialog .range-selector .noUi-connect{background:#47c54f}.batch-settings-dialog .range-selector .noUi-handle{height:22px;width:18px}.batch-settings-dialog .range-selector .noUi-handle:before{left:5px;top:3px}.batch-settings-dialog .range-selector .noUi-handle:after{left:10px;top:3px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
